import { render, staticRenderFns } from "./consolidated-request-bank-statements.vue?vue&type=template&id=5623efbb"
import script from "./consolidated-request-bank-statements.vue?vue&type=script&lang=js"
export * from "./consolidated-request-bank-statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports